import { render, staticRenderFns } from "./PatientTierPanel.vue?vue&type=template&id=a5c0e818"
import script from "./PatientTierPanel.vue?vue&type=script&lang=js"
export * from "./PatientTierPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports